<template>
<a class="sl-a-download sl-el-btn el-button el-icon-sl-download" :href="href" download>
  <span>{{text}}</span>
</a>
</template>
<script>
export default {
  name: 'sl-btn',
  props: {
    text: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    }
  }
}
</script>
<style>
.sl-a-download.sl-el-btn.el-button span {
  font-family: Avenir-Book;
}

.sl-a-download.sl-el-btn.el-button {
  border-radius: 2px;
  background: #FFFFFF;
  border: 1px solid #C8C8C8;
  padding: 8px;
  font-size: 12px;
  color: #000000;
}

.sl-a-download.sl-el-btn.el-button:hover {
  background: #FFFBF8;
  border: 1px solid #E16607;
  border-radius: 2px;
  color: #E16607;
  text-decoration: none;
}

.sl-a-download.el-icon-sl-download:before {
  font-size: 8px;
  position: relative;
  top: -1px;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// sl-a.vue?35739f0e